import {Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, TextField} from '@mui/material';
import Button from '@mui/material/Button';
import React from 'react';
import PropTypes from 'prop-types';
import {ezprOrange} from '../../_helpers';
import {requestStores} from '../../ListOfPREditors.brick.jsx';
import {PurchaseRequest} from '../../../models/PurchaseRequest';

/**
 * A popup allowing the NBS OB to send a message explaining why he denied the request
 * @param {DenyPRPopup.propTypes} props
 * @return {JSX.Element}
 * @constructor
 */
export function DenyPRPopup(props) {
    const useRequestStore = requestStores.get(props.prTag);
    const [denialInfo, setDenialInfo] = useRequestStore((state) => [state.denialInfo, state.setDenialInfo]);
    const [sbDenialInfo, setSBDenialInfo] = useRequestStore((state) => [state.sbDenialInfo, state.setSBDenialInfo]);

    const handleCommentChange = (event) => {
        if (props?.currentTab === PurchaseRequest.statuses.pendingNbs) {
            setDenialInfo({
                ...denialInfo,
                denialReason: event.target.value,
            });
        } else if (props?.currentTab === PurchaseRequest.statuses.pendingSB) {
            setSBDenialInfo({
                ...sbDenialInfo,
                denialReason: event.target.value,
            });
        }
    };

    return (
        <Dialog
            onClose={props.onClose}
            open={props.open}
            aria-labelledby="deny-pr-popup"
        >
            <div style={{display: 'flex'}}>
                <div style={{backgroundColor: ezprOrange, width: '20%', height: 'auto', display: 'flex', alignItems: 'center', minWidth: '50px', justifyContent: 'center'}}>
                    <i className="material-icons" style={{color: 'white'}}>cancel</i>
                </div>
                <div>
                    <DialogTitle id="popup-title">{'You denied this request.'}</DialogTitle>
                    <DialogContent>
                        <DialogContentText>
                            Please insert a comment explaining why you denied this request.
                            This comment will be shown to the Spender/Requester.
                        </DialogContentText>
                        <TextField
                            autoFocus
                            fullWidth
                            variant={'outlined'}
                            multiline
                            rows={3}
                            label={'Your comment'}
                            sx={{marginTop: '15px'}}
                            defaultValue={denialInfo?.denialReason}
                            onBlur={handleCommentChange}
                        />
                    </DialogContent>
                    <DialogActions>
                        <Button onClick={props.onCancel}>
                            Cancel
                        </Button>
                        <Button onClick={props.onClose}>
                            Ok
                        </Button>
                    </DialogActions>
                </div>
            </div>
        </Dialog>
    );
}

DenyPRPopup.propTypes = {
    prTag: PropTypes.string.isRequired,
    onClose: PropTypes.func.isRequired,
    onCancel: PropTypes.func.isRequired,
    open: PropTypes.bool.isRequired,
    currentTab: PropTypes.string,
};
